import { fetchData, postData } from 'modules/Axios';
import { notifyFailure, notifySuccess } from 'modules/Notifications';

export const defaultState = {
  integration: null,
  integrationTypes: {},
};

export const CREATE_INTEGRATION = 'CREATE_INTEGRATION';

export const createIntegration = (integration) => ({
  type: CREATE_INTEGRATION,
  payload: integration,
});

export const saveIntegration = (integrationDTO) => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    const integration = await dispatch(postData(`brands/${brand.id}/integrations`, { ...integrationDTO }))
      .then((result) => {
        notifySuccess('Integration Created Successfully');
        return result;
      })
      .catch((e) => {
        console.error('API Call to create integration failed...', e);
        notifyFailure('Failed to create integration');
        return null;
      });

    return integration;
  };
};

export const RECEIVE_INTEGRATION_TYPES = 'RECEIVE_INTEGRATION_TYPES';

export const receiveIntegrationTypes = (payload) => ({
  type: RECEIVE_INTEGRATION_TYPES,
  payload,
});

export const GET_INTEGRATION_TYPES = 'GET_INTEGRATION_TYPES';

export const getIntegrationTypes = () => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    const URL = `/brands/${brand.id}/audiences/destinations`;
    try {
      const destinations = await dispatch(fetchData(URL));
      dispatch(receiveIntegrationTypes(destinations));
    } catch (e) {
      console.error('API Call to /integrationTypes failed...', e);
      notifyFailure('Failed to retrieve integration types');
    }
  };
};

export const saveSshFile = (fileData, updateFileUploadingProgress) => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    try {
      const getSshKeyId = await dispatch(postData(`brands/${brand.id}/integrations/ssh_keys`, fileData, null, true, 'json', updateFileUploadingProgress));
      return getSshKeyId;
    } catch (e) {
      console.error('API Call to upload audience file failed...', e);
      notifyFailure('Failed to upload audience file');
      return null;
    }
  };
};

export const saveEncryptionFile = (fileData, updateFileUploadingProgress) => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    try {
      const getEncryptionKeyId = await dispatch(postData(`brands/${brand.id}/integrations/encryption_keys`, fileData, null, true, 'json', updateFileUploadingProgress));
      return getEncryptionKeyId;
    } catch (e) {
      console.error('API Call to upload audience file failed...', e);
      notifyFailure('Failed to upload audience file');
      return null;
    }
  };
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case CREATE_INTEGRATION:
      return {
        ...state,
        integration: action.payload.integration,
      };
    case RECEIVE_INTEGRATION_TYPES:
      return {
        ...state,
        integrationTypes: action.payload,
      };
    default:
      return state;
  }
}
